"use strict";
/**
 * Allocate a **Xero Payment** against an existing **ACCREC** created by
 * {@link ACCOUNTING_SYNC_OPERATION_CREATE_XERO_INVOICE_FROM_HANDSHAKE_PROJECT_INVOICE}.
 *
 * ## Trigger
 * When Handshake **releases funds from escrow** to the business (milestone payment request accepted by client),
 * not when the client first pays into escrow.
 *
 * **Idempotency**: one logical allocation per `(projectInvoiceId, idempotencySuffix)` — use a stable suffix
 * (e.g. `message_request.id` or `instant_release`).
 *
 * ## Operation string
 * Prefer {@link ACCOUNTING_SYNC_OPERATION_ALLOCATE_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE}
 * (legacy Xero value still accepted — see {@link isAllocatePaymentAccountingSyncOp}).
 *
 * ## Idempotency key
 * `${ACCOUNTING_INVOICE_PAYMENT_SYNC_IDEMPOTENCY_PREFIX}${projectInvoiceId}:${suffix}`
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_INVOICE_PAYMENT_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_ALLOCATE_XERO_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE = exports.ACCOUNTING_SYNC_OPERATION_ALLOCATE_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE = void 0;
exports.isAllocatePaymentAccountingSyncOp = isAllocatePaymentAccountingSyncOp;
exports.parseProjectInvoicePaymentIdempotencyKey = parseProjectInvoicePaymentIdempotencyKey;
/** Provider-neutral allocate-payment sync operation (preferred for new writes). */
exports.ACCOUNTING_SYNC_OPERATION_ALLOCATE_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE = "ALLOCATE_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE";
/**
 * Legacy Xero-branded operation string — still present in existing idempotency rows.
 * Prefer {@link ACCOUNTING_SYNC_OPERATION_ALLOCATE_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE} for new writes.
 */
exports.ACCOUNTING_SYNC_OPERATION_ALLOCATE_XERO_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE = "ALLOCATE_XERO_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE";
/** True when `operation` is the neutral or legacy Xero allocate-payment op. */
function isAllocatePaymentAccountingSyncOp(operation) {
    return (operation === exports.ACCOUNTING_SYNC_OPERATION_ALLOCATE_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE ||
        operation === exports.ACCOUNTING_SYNC_OPERATION_ALLOCATE_XERO_PAYMENT_FOR_HANDSHAKE_PROJECT_INVOICE);
}
exports.ACCOUNTING_INVOICE_PAYMENT_SYNC_IDEMPOTENCY_PREFIX = "project_invoice_payment:";
const PROJECT_INVOICE_PAYMENT_KEY_UUID = /^project_invoice_payment:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(.+)$/i;
/** Parses `project_invoice_payment:{invoiceId}:{suffix}` idempotency keys. */
function parseProjectInvoicePaymentIdempotencyKey(idempotencyKey) {
    const match = idempotencyKey.match(PROJECT_INVOICE_PAYMENT_KEY_UUID);
    if (!match) {
        return null;
    }
    return { projectInvoiceId: match[1], idempotencySuffix: match[2] };
}
